import styled, { css } from 'styled-components';

export const DropdownContainer = styled.div<{
  highlighted: boolean;
  validationIssue: boolean;
  isDisabled: boolean;
  pendingItem: boolean;
}>`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  background-color: ${({ highlighted }) => (highlighted ? 'var(--cl-yellow-100)' : '')};
  align-items: center;

  ${({ validationIssue }) => (validationIssue && css`
    background-color: var(--cl-red-100);
    border-radius: var(--cl-radius-1);
  `)};

  ${({ isDisabled }) => (isDisabled && css`
    cursor: not-allowed;
    color: var(--cl-gray-500);
  `)};

  ${({ pendingItem }) => (pendingItem && css`
    margin-left: -5px;
    margin-right: -7px;
  `)}
`;
